import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { AgenciesService } from 'src/app/api/tourism/agencies.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { HttpHeaders } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-agencies-form',
  templateUrl: './agencies-form.component.html',
  styleUrls: ['./agencies-form.component.css']
})
export class AgenciesFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // array values
  detail_managers: any = [];

  // set values variables
  imageUrl: any = null;
  fileUrlImage: any = null;
  service_alert: any = {
    class: 'success',
    message: '',
    show: false
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private agencyService: AgenciesService,
    private generalService: GeneralService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      tradename: [null, [Validators.required, Validators.minLength(2)]],
      document: [null, [Validators.required]],
      fullname: [null],
      cellphone: [null],
      telephone: [null],
      email: [null],
      address: [null],
      url_image: [null],
      annotations: [null],
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
      this.agencyService.get(this.checkId).subscribe({
        next: (data: any) => {
          let result_ = data.data;
          this.item.patchValue({
            tradename: result_.tradename,
            document:  result_.document,
            fullname:  result_.fullname,
            cellphone:  result_.cellphone,
            telephone:  result_.telephone,
            email:  result_.email,
            address:  result_.telephone,
            url_image:  result_.url_image,
            annotations:  result_.annotations,
          });

          this.detail_managers = result_.managers_data
        }
      });
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  extractRuc() {
    let param_ = this.item.value.document;
    if (param_ != null) {
      this.generalService.extractRuc(param_).subscribe({
        next: (data: any) => {
          if (data.success) {
            this.replaceExtractDataRuc(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataRuc(data: any) {
    console.log(data);
    this.item.patchValue({
      fullname: data.name,
      address: data.address
    });

    this.service_alert.class = data.alert_status;
    this.service_alert.message =
      'El RUC se encuentra con estado ' +
      data.status +
      ' y en condición ' +
      data.condition;
    this.service_alert.show = true;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }


  addManagerItem() {
    let obj_:any = {};
    obj_.id = null;
    obj_.detail_id = null;
    obj_.fullname = null;
    obj_.document = null;
    obj_.cellphone = null;
    obj_.email = null;
    obj_.charge = null;
    obj_.observations = null;
    this.detail_managers.push(obj_);

    setTimeout(() => {
      let last_index = this.detail_managers.length - 1;
      (<any>$('#manager_fullname'+last_index)).focus();
    }, 150);
  }

  changeManagerFullname(param: any, index: number): void {
    let value_ = param.value;
    this.detail_managers[index].fullname = value_;
  }

  changeManagerCellphone(param: any, index: number): void {
    let value_ = param.value;
    this.detail_managers[index].cellphone = value_;
  }

  changeManagerEmail(param: any, index: number): void {
    let value_ = param.value;
    this.detail_managers[index].email = value_;
  }

  changeManagerCharge(param: any, index: number): void {
    let value_ = param.value;
    this.detail_managers[index].charge = value_;
  }

  changeManagerObservations(param: any, index: number): void {
    let value_ = param.value;
    this.detail_managers[index].observations = value_;
  }

  removeManager(id: any, index: any) {
    this.detail_managers.splice(index, 1);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append('detail_managers', JSON.stringify(this.detail_managers));
      formData.append('url_image', this.fileUrlImage);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.agencyService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.agencyService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if(this.detail_managers.length > 0){
      for (let i in this.detail_managers) {
        let item_ = this.detail_managers[i];

        if(_.isNull(item_.fullname) || _.isEmpty(item_.fullname)){
          (<any>$('#manager_fullname'+i)).focus();
          this.alertifyMsg.warning("El nombre del encargado no puede estar vacío");
          return false;
        }

        if(_.isNull(item_.cellphone) || _.isEmpty(item_.cellphone)){
          (<any>$('#manager_cellphone'+i)).focus();
          this.alertifyMsg.warning("El n° de celular del encargado no puede estar vacío");
          return false;
        }
      }
    }
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/turismo/agencias/lista']);
  }
}
